<template>
  <div v-if="taskTypeInView">
    <div class="row">
      <div class="col-12 mb-3">
        <div class="wfh-v-select-override wfh-sm">
          <v-select
              :options="taskTypes"
              :filterable="false"
              :clearable="false"
              v-model="taskTypeInView"
              :reduce="(item) => item.value"
          >
          </v-select>
        </div>
      </div>
    </div>

    <HourlyTaskList
        v-if="taskTypeInView === 'hourly'"
        :yourHourlyTasks="yourHourlyTasks"
        @storeTasksLocally="storeTasksLocally"
    />

    <TodoTaskList
        v-if="taskTypeInView === 'checklist'"
        :yourTodoTasks="yourTodoTasks"
        :yourGoals="yourGoals"
        @storeTasksLocally="storeTasksLocally"
    />

    <PlayableTaskList
        v-if="taskTypeInView === 'playable'"
    />

    <PersonalTaskSummaryList
        v-if="taskTypeInView === 'summary'"
        @storeTasksLocally="storeTasksLocally"
    />
  </div>
</template>

<script>
import vSelect from 'vue-select';
import HourlyTaskList from '../Lists/HourlyTaskList';
import TodoTaskList from '../Lists/TodoTaskList';
import PlayableTaskList from '../Lists/PlayableTaskList';
import PersonalTaskSummaryList from '../Lists/PersonalTaskSummaryList';
import { TASK_TYPES } from './DefaultOptions';

export default {
  components: { PersonalTaskSummaryList, PlayableTaskList, TodoTaskList, HourlyTaskList, vSelect },

  props: ['yourTodoTasks', 'yourHourlyTasks', 'yourGoals'],

  data () {
    return {
      taskTypeInView: null,
      taskTypes: [],
    };
  },

  watch: {
    taskTypeInView () {
      localStorage.setItem('wfh_taskType_viewed', this.taskTypeInView);
    },
  },

  methods: {
    storeTasksLocally (eventData) {
      this.$emit('storeTasksLocally', eventData);
    },
  },

  mounted () {
    if (!hasPermission('check_ins') && TASK_TYPES[0].value === 'hourly') {
      TASK_TYPES.shift();

      if (localStorage.getItem('wfh_taskType_viewed') === 'hourly') {
        localStorage.removeItem('wfh_taskType_viewed');
      }
    }

    this.taskTypes = TASK_TYPES;
    this.taskTypeInView = localStorage.getItem('wfh_taskType_viewed') ?? TASK_TYPES[0].value;
  }
};
</script>

<style scoped lang="scss">
.btn-link {
  i {
    color: #0096f5;
  }
}
</style>
